import ChatAction from '../models/ChatAction'

export default class EventHandler {
  constructor() {
    this.addEvent = null
    this.setState = null
  }

  setAddEvent(addEvent) {
    this.addEvent = addEvent
  }

  setSetState(setState) {
    this.setState = setState
  }

  registerForEvents(client) {
    this.client = client

    window.addEventListener(
      'PRIVMSG',
      function(command) {
        const message = new ChatAction()
        message.fromCommand(command.detail)
        message.id = message.timestamp.getTime()
        this.addEvent(message)
      }.bind(this),
    )

    window.addEventListener(
      'rpl_namreply',
      function(command) {
        let nicks = command.detail.args[3].split(' ')
        nicks = nicks.map(function(nick) {
          if (nick.substring(0, 1) === '@') {
            return nick.substring(1)
          }
          return nick
        })
        this.setState({ users: nicks })
      }.bind(this),
    )

    window.addEventListener(
      'rpl_topic',
      function(command) {
        const topic = command.detail.args[2]
        this.setState({ topic: topic })
      }.bind(this),
    )

    window.addEventListener(
      'TOPIC',
      function(command) {
        const message = new ChatAction()
        message.fromCommand(command.detail)
        this.addEvent(message)
      }.bind(this),
    )

    window.addEventListener(
      'JOIN',
      function(command) {
        const message = new ChatAction()
        message.fromCommand(command.detail)
        this.addEvent(message)
        const channel = message.args[0]
        this.client.sendData(`NAMES ${channel}`)
      }.bind(this),
    )

    window.addEventListener(
      'PART',
      function(command) {
        const message = new ChatAction()
        message.fromCommand(command.detail)
        this.addEvent(message)
        const channel = message.args[0]
        this.client.sendData(`NAMES ${channel}`)
      }.bind(this),
    )

    window.addEventListener(
      'QUIT',
      function(command) {
        const message = new ChatAction()
        message.fromCommand(command.detail)
        message.target = this.client.channel
        this.addEvent(message)
        this.client.sendData(`NAMES ${this.client.channel}`)
      }.bind(this),
    )

    window.addEventListener(
      'KICK',
      function(command) {
        const message = new ChatAction()
        message.fromCommand(command.detail)
        this.addEvent(message)
      }.bind(this),
    )

    window.addEventListener(
      'SELFDIDJOIN',
      function(command) {
        this.setState({ connecting: false, loggedIn: true })
      }.bind(this),
    )

    window.addEventListener(
      'NICK',
      function(command) {
        const message = new ChatAction()
        message.fromCommand(command.detail)
        this.addEvent(message)
      }.bind(this),
    )
  }
}



// WEBPACK FOOTER //
// ./src/irc/EventHandler.js